<div class="column drawer-dialog drawer-dialog-full-screen">
	<div class="drawer-dialog-header">
		<h2 i18n="@@deviceGenerateOneDayCode-generateCode" data-automation-id="deviceGenerateOneDayCode-generateCode">
			Generate Code
		</h2>
		<button mat-icon-button (click)="onCloseClicked()" data-automation-id="device-gen-code-close-button">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<app-not-authorized-notice has="issueFlexCodes"></app-not-authorized-notice>

	@if (canIssueFlexCodes) {
		@if (codeSuccessfullyGenerated) {
			<mat-dialog-content class="drawer-dialog-content">
				<div class="drawer-dialog-content-header small-padding-bottom">
					<b i18n="@@deviceGenerateOneDayCode-confirmationCodeGenerationTitle-Confirmation">Confirmation</b> |
					@if (isHaspCodeGenForm) {
						<span
							i18n="@@deviceGenerateOneDayCode-confirmationCodeGenerationTitle-HaspCodeGeneration"
							data-automation-id="deviceGenerateCode-confirmationAccessCodeScreenTitle-HaspCodeGeneration"
							>Hasp Code Generation</span
						>
					}
					@if (!isHaspCodeGenForm && !isPDQDevice && !isSentriVaultDeviceFlag) {
						<span
							i18n="@@deviceGenerateOneDayCode-confirmationScreenTitle-AccessCodeGeneration"
							data-automation-id="deviceGenerateCode-confirmationAccessCodeScreenTitle-AccessCodeGeneration"
							>Access Code Generation</span
						>
					}
					@if (!isHaspCodeGenForm && isPDQDevice) {
						<span
							i18n="@@deviceGenerateOneDayCode-confirmationSenturianScreenTitle-SenturianCodeGeneration"
							data-automation-id="deviceGenerateCode-confirmationSanturianScreenTitle-SanturianNameHeader"
							>Senturian Code Generation</span
						>
					}
					<!-- Added the Sentri-Vault Code Generation : -->
					@if (!isHaspCodeGenForm && isSentriVaultDeviceFlag) {
						<span
							i18n="@@deviceGenerateCode-confirmationSentrivaultScreenTitle-SentrivaultNameHeader"
							data-automation-id="deviceGenerateCode-confirmationSentrivaultScreenTitle-SentrivaultNameHeader"
							>SentriVault Code Generation</span
						>
					}
				</div>
				@if (hasCompanionOneDayCode) {
					<div class="companion-codes-banner" data-automation-id="companion-codes-banner">
						<mat-icon class="color-secondary-orange">error_outline</mat-icon>
						<div class="column companion-banner-copy">
							<span class="companion-banner-title" i18n="@@deviceGenerateOneDayCode-companionBannerTitle"
								>Two codes for this box</span
							>
							@if (companionWindowStartLabel) {
								<span class="companion-banner-body" i18n="@@deviceGenerateOneDayCode-companionBannerBody"
									>Use the first code until {{ companionWindowStartLabel }}. After that, use the second code.</span
								>
							}
						</div>
					</div>
					@if (companionWindowStartLabel) {
						<span
							class="requested-window-label"
							data-automation-id="requested-window-label"
							i18n="@@deviceGenerateOneDayCode-requestedWindowLabel"
							>Until {{ companionWindowStartLabel }}</span
						>
					}
				}
				<div class="row spacing-24">
					<app-device-generate-code-box
						[oneDayCode]="oneDayOrFlexCodeEdits.oneDayOrFlexCode"
						[showIcon]="isHaspCodeGenForm"
						[isPDQDevice]="isPDQDevice"
					></app-device-generate-code-box>
					<div class="column">
						<div class="icon-centered">
							<mat-icon class="color-action valid-date-icon" svgIcon="sl-calendar-date"></mat-icon>
							@if ((device.deviceGeneration?.toLowerCase() ?? '').includes('gen3')) {
								<span class="spacing-left valid-date-text">Valid {{ oneDayOrFlexCodeEdits.utcValidDate }}</span>
							}
							@if ((device.deviceGeneration?.toLowerCase() ?? '').includes('gen4') || isPDQDevice) {
								<span class="spacing-left valid-date-range-container valid-date-text"
									>Valid {{ oneDayOrFlexCodeEdits.startDate }} {{ oneDayOrFlexCodeEdits.startTime }} -
									{{ oneDayOrFlexCodeEdits.endDate }} {{ oneDayOrFlexCodeEdits.endTime }}</span
								>
							}
						</div>
						@if (
							(device.deviceGeneration?.toLowerCase() ?? '').includes('gen3') &&
							!isHaspCodeGenForm &&
							!hasCompanionOneDayCode
						) {
							<div class="display-flex">
								<mat-icon class="color-secondary-orange">error_outline</mat-icon>
								<span
									class="mat-body-2 spacing-left one-day-code-expire-text"
									i18n="@@deviceGenerateOneDayCode-oneDayCodeExpireText"
									>One Day Code will expire at end of day</span
								>
							</div>
						}
					</div>
				</div>
				@if (hasCompanionOneDayCode) {
					<div class="companion-code-block" data-automation-id="companion-code-block">
						@if (companionWindowStartLabel) {
							<span
								class="companion-window-label"
								data-automation-id="companion-window-label"
								i18n="@@deviceGenerateOneDayCode-companionWindowLabel"
								>After {{ companionWindowStartLabel }}</span
							>
						}
						<p class="companion-code-text" data-automation-id="companion-code-value">
							{{ companion?.oneDayCode }}
						</p>
						<span class="companion-valid-date" data-automation-id="companion-valid-date"
							>Valid {{ companion?.utcValidDate }}</span
						>
					</div>
				}
				<ng-container *ngTemplateOutlet="deviceLocation"></ng-container>
				<mat-divider></mat-divider>
				<div class="column top-spacing bottom-spacing">
					<span class="title-text" i18n="@@deviceGenerateOneDayCode-reasonForGenerationTitleColumn"
						>Reason For Generation</span
					>
					<p class="body-text generation-text">{{ oneDayOrFlexCodeEdits.reason }}</p>
					@if (
						isHaspCodeGenForm &&
						oneDayOrFlexCodeEdits &&
						oneDayOrFlexCodeEdits.newLocation &&
						oneDayOrFlexCodeEdits.newLocation !== ''
					) {
						<span class="title-text" i18n="@@deviceGenerateOneDayCode-newDeviceLocation">New Device Location</span>
						<p class="body-text generation-text">{{ oneDayOrFlexCodeEdits.newLocation }}</p>
					}
					<span class="title-text" i18n="@@deviceGenerateOneDayCode-assignToTitleColumn">Assigned To</span>
					<span class="body-text generation-text"
						>{{ oneDayOrFlexCodeEdits.firstName }} {{ oneDayOrFlexCodeEdits.lastName }}</span
					>
					<span class="body-text generation-text">{{ oneDayOrFlexCodeEdits.email }}</span>
					<span class="body-text generation-text">{{ oneDayOrFlexCodeEdits.mobilePhoneNumber }}</span>
					@if (wasConfirmationSent()) {
						<mat-chip-set class="margin-top-8">
							<mat-chip class="filter-chip">
								<span class="removeIconCenterHack margin-right-4">
									<mat-icon class="filter-chip-remove-icon">check</mat-icon>
								</span>
								<span class="mat-chip-text" i18n="@@deviceGenerateOneDayCode-confirmationSentText"
									>Confirmation Sent</span
								>
							</mat-chip>
						</mat-chip-set>
					}
				</div>
				<mat-divider></mat-divider>
				@if ((device.deviceGeneration?.toLowerCase() ?? '').includes('gen3')) {
					<div class="column top-spacing bottom-spacing">
						<div class="body-text icon-text-magenta">
							<mat-icon>help_outline</mat-icon
							><span class="spacing-left" i18n="@@deviceGenerateOneDayCode-gen3HowToUseTitle"
								>How To Use This Code</span
							>
						</div>
						@if (!isHaspCodeGenForm) {
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen3Direction1Text"
								>1. Press ENT button on the lockbox</span
							>
						}
						@if (isHaspCodeGenForm) {
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen3Direction1HaspText"
								>1. Press ENT then FUNC button on the lockbox</span
							>
						}
						<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen3Direction2Text"
							>2. Enter the generated code shown above</span
						>
						<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen3Direction3Text"
							>3. Press ENT button on the lockbox</span
						>
						@if (!isHaspCodeGenForm) {
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen3Direction4Text">4. Key door will open</span>
						}
						@if (isHaspCodeGenForm) {
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen3HaspDirection4Text"
								>4. Hasp will release
							</span>
						}
					</div>
				}
				@if (isGen4Device && !isSentriVaultDeviceFlag) {
					<div class="column top-spacing bottom-spacing">
						<div class="body-text icon-text-magenta">
							<mat-icon>help_outline</mat-icon
							><span class="spacing-left" i18n="@@deviceGenerateOneDayCode-gen4HowToUseTitle"
								>How To Use This Code</span
							>
						</div>
						<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen4Direction1Text"
							>1. Press the ENT button on the device</span
						>
						<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen4Direction2Text"
							>2. Enter {{ oneDayOrFlexCodeEdits.oneDayOrFlexCode }}</span
						>
						<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen4Direction3Text"
							>3. Press the ENT button on the device</span
						>
						@if (!isHaspCodeGenForm) {
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen4Direction4Text">4. Key door will open</span>
						}
						@if (isHaspCodeGenForm) {
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-gen4HaspDirection4Text"
								>4. Hasp will release
							</span>
						}
					</div>
				}
				@if (isPDQDevice) {
					<div class="column top-spacing bottom-spacing">
						<div class="body-text icon-text-magenta">
							<mat-icon>help_outline</mat-icon
							><span class="spacing-left" i18n="@@deviceGenerateOneDayCode-gen4HowToUseTitle"
								>How To Use This Code</span
							>
						</div>
						<div class="pdq-direction-container">
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-pdq1Direction1Text">1. Enter </span>
							<span class="body-text font-weight-bold">{{ oneDayOrFlexCodeEdits.oneDayOrFlexCode }}</span>
						</div>
						<div class="pdq-direction-container">
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-pdq1Direction2aText">2. Press the </span>
							<span class="body-text font-weight-bold" i18n="@@deviceGenerateOneDayCode-pdq1Direction2bText"
								>Unlock</span
							>
							<span class="body-text" i18n="@@deviceGenerateOneDayCode-pdq1Direction2cText">button</span>
						</div>
						<span class="body-text" i18n="@@deviceGenerateOneDayCode-pdq1Direction3Text">3. Device will unlock</span>
					</div>
				}
				<!-- Added for the Sentri-Vault Device after code generation usage : -->
				@if (isSentriVaultDeviceFlag) {
					<div class="column top-spacing bottom-spacing">
						<div class="body-text icon-text-magenta">
							<mat-icon>help_outline</mat-icon>
							<span class="spacing-left" i18n="@@deviceGenerateOneDayCode-gen4HowToUseTitle">
								How To Use This Code
							</span>
						</div>

						<!-- For Unlock Section : -->
						<div class="vault-instructions-section">
							<div class="body-text font-weight-bold section-title" i18n="@@deviceGenerateCode-unlockTitle">Unlock</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceFlexCodeGeneration-pressFirstText"> 1. Press </span>
								<span class="body-text font-weight-bold" i18n="@@deviceFlexCodeGeneration-ENTFirstText"> ENT </span>
								<span class="body-text" i18n="@@deviceFlexCodeGeneration-onTheDeviceFirstText"> on the device </span>
							</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceGenerateCode-enterCodeText"> 2. Enter </span>
								<span class="body-text font-weight-bold">
									{{ oneDayOrFlexCodeEdits.oneDayOrFlexCode }}
								</span>
							</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceGenerateCode-pressEntAgainText"> 3. Press </span>
								<span class="body-text font-weight-bold">ENT</span>
								<span class="body-text" i18n="@@deviceGenerateCode-onTheDeviceAgainText"> on the device </span>
							</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceGenerateOneDayCode-removeLidFromVaultText">
									4. Remove lid from vault
								</span>
							</div>
						</div>

						<!-- For Lock Section : -->
						<div class="vault-instructions-section top-spacing-for-steps">
							<div class="body-text font-weight-bold section-title" i18n="@@deviceGenerateCode-lockTitle">Lock</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceGenerateCode-replaceLidOnVaultText">
									1. Replace lid on vault
								</span>
							</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceGenerateCode-pressEntLockText"> 2. Press </span>
								<span class="body-text font-weight-bold">ENT</span>
								<span class="body-text" i18n="@@deviceGenerateCode-onTheDeviceLockText"> on the device </span>
							</div>

							<div class="pdq-direction-container">
								<span class="body-text" i18n="@@deviceGenerateCode-pressFncLockText"> 3. Press </span>
								<span class="body-text font-weight-bold">FNC/Lock</span>
								<span class="body-text" i18n="@@deviceGenerateCode-forFiveSecondsText"> for 5 seconds </span>
							</div>
						</div>
					</div>
				}
			</mat-dialog-content>
		} @else {
			<mat-dialog-content class="drawer-dialog-content">
				@if (!fromDeviceScreen) {
					<div>
						<div class="device-lookup-header">
							<div
								id="sn-search-bar"
								class="drawer-dialog-content-header large-title-formatting-device-lookup"
								i18n="@@deviceGenerateOneDayCode-deviceLookup"
							>
								Device Lookup
							</div>
						</div>
						<!-- Device lookup form (look up by serial number, property name, or device location) -->
						<div class="sn-lookup-rows align-items-end margin-bottom-16">
							<div class="sn-lookup-columns margin-bottom-5 column">
								<div class="label-text-formatting search-instructions">
									{{ deviceLookupInstructionsPlaceholder }}
								</div>
								<div class="search-bar">
									<div class="serial-number-search">
										<div class="serial-number-search-title">{{ serialNumberPlaceholder }}</div>
										<app-device-search-bar
											#serialSearchBar
											[searchAllDevices]="true"
											[searchType]="'serialNumber'"
											[externalSelectedDevice]="selectedDeviceForSync"
											(selectedDeviceEvents)="onDeviceSelectedEvent($event)"
										></app-device-search-bar>
									</div>
									@if (!device.id) {
										<div class="property-search">
											<div class="property-search-title">{{ propertyNamePlaceholder }}</div>
											<app-device-search-bar
												#deviceSearchBar
												[searchAllDevices]="true"
												[searchType]="'propertyName'"
												(selectedDeviceEvents)="onDeviceSelectedEvent($event)"
											></app-device-search-bar>
										</div>
										<div class="device-location-search">
											<div class="device-location-search-title">{{ deviceLocationPlaceholder }}</div>
											<app-device-search-bar
												#deviceSearchBar
												[searchAllDevices]="true"
												[searchType]="'deviceLocation'"
												(selectedDeviceEvents)="onDeviceSelectedEvent($event)"
											></app-device-search-bar>
										</div>
									}
								</div>
							</div>
							@if (device.deviceGeneration) {
								<div>
									@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
										<div>
											<img
												class="lb-img"
												src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
												alt="Gen 4 Lockbox"
												data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
											/>
										</div>
									}
									@if (device.deviceGeneration.toLowerCase().includes('gen3')) {
										<div>
											<img
												class="lb-img"
												src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
												alt="Gen 3 Lockbox"
												data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
											/>
										</div>
									}
									@if (device.deviceGeneration.includes(PDQ_KMS_GENERATION_1)) {
										<div>
											<img
												class="lb-img kms-lockset-img"
												src="${environment.deployPath}/../assets/icons/senturian-1-kms.png"
												alt="Senturian Series Deadbolt"
												data-automation-id="deviceGenerateCodeDialog-santurianSeriesDeadboltDeviceImage"
											/>
										</div>
									}
									@if (device.deviceGeneration.includes(PDQ_SDS_GENERATION_1)) {
										<div>
											<img
												class="lb-img sds-lockset-img"
												src="${environment.deployPath}/../assets/icons/senturian-1-sds.png"
												alt="Senturian Series Cylindrical"
												data-automation-id="deviceGenerateCodeDialog-santurianSeriesCylindricalDeviceImage"
											/>
										</div>
									}
									<!-- Added for the Sentri-Vault image based on conditionally : -->
									@if (isSentriVaultDeviceFlag) {
										<div>
											<img
												class="lb-img sds-lockset-img"
												src="${environment.deployPath}/../assets/icons/sentrivault.png"
												alt="SentriVault"
												data-automation-id="deviceGenerateCodeDialog-sentrivaultDeviceImage"
											/>
										</div>
									}
								</div>
							}
						</div>
						@if (device.id) {
							<div class="device-location-info">
								<div class="column body-text">
									<span class="color-type-tertiary" i18n="@@deviceGenerateOneDayCode-addresTitle">Address</span>
									@if (
										this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
											?.address1 &&
										this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
											?.locality &&
										this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
											?.postalCode
									) {
										<p>
											{{
												this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.address1
											}},
											{{
												this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.locality
											}},
											{{
												this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.postalCode
											}}
										</p>
									}
									@if (
										!this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
											?.address1 ||
										!this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
											?.locality ||
										!this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
											?.postalCode
									) {
										<p>- - -</p>
									}
								</div>
								<div class="column body-text">
									<span class="color-type-tertiary" i18n="@@deviceGenerateOneDayCode-propertyNameTitle"
										>Property Name</span
									>
									<p>
										{{
											this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name ??
												'- - -'
										}}
									</p>
								</div>
								<div class="column body-text">
									<span class="color-type-tertiary" i18n="@@deviceGenerateOneDayCode-deviceLocationTitle"
										>Device Location</span
									>
									<p>
										{{ this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name ?? '- - -' }}
									</p>
								</div>
							</div>
						}
					</div>
				}
				<!-- Section where the form is put together -->
				@if (!!device.id && this.resultingDeviceAccess) {
					@if (
						!fromDeviceScreen &&
						(this.fetchingDeviceControlSummaries ||
							this.resultingDeviceAccess.length === 0 ||
							this.resultingDeviceAccess)
					) {
						<mat-divider></mat-divider>
					}
					@if (this.fetchingDeviceControlSummaries) {
						<div>
							<span i18n="@@@deviceGenerateOneDayCode-fetchingControls">Fetching controls...</span>
						</div>
					}
					@if (!this.fetchingDeviceControlSummaries && this.resultingDeviceAccess.length === 0) {
						<div>
							<span i18n="@@@deviceGenerateOneDayCode-noControlsFound">No device access controls found.</span>
						</div>
					}
					@if (!this.fetchingDeviceControlSummaries) {
						<h3
							class="font-weight-400 font-size-14 inheritance-bubbles-text inheritance-bubble-header-text"
							i18n="@@deviceGenerateOneDayCode-GrantAccessSelection"
						>
							Get started by clicking on an access you've been granted
						</h3>
						<mat-grid-list cols="1" [rowHeight]="gridRowHeight" gutterSize="5px">
							@for (deviceAccess of resultingDeviceAccess; track deviceAccess.control.id || deviceAccess.control.name) {
								<mat-grid-tile
									id="inherited_control_mat_grid"
									(click)="onSelectedInheritorChangedEvent(deviceAccess)"
									[attr.data-automation-id]="'device-access-' + deviceAccess.control"
								>
									<div
										class="column resulting-device-access-container"
										[class.selected]="deviceAccess.control.name === 'selected'"
										[class.notSelected]="deviceAccess.control.name !== 'selected'"
									>
										<div class="column">
											<p class="resulting-device-access-control-header">
												{{ formatControlName(deviceAccess.control) }}
											</p>
											<div class="row">
												<div class="column-double">
													<p
														class="resulting-device-access-control-day-time inheritance-bubbles-text"
														[innerHTML]="deviceAccess.control | deviceControlDays"
													></p>
												</div>
												<div>
													<p class="resulting-device-access-control-duration inheritance-bubbles-text">
														{{ deviceAccess.assignments | deviceAccessControlDuration }}
													</p>
												</div>
											</div>
										</div>
									</div>
								</mat-grid-tile>
							}
						</mat-grid-list>
					}
					@if (
						this.fetchingDeviceControlSummaries || this.resultingDeviceAccess.length === 0 || this.resultingDeviceAccess
					) {
						<mat-divider></mat-divider>
					}
				}
				@if (isHaspCodeGenFeatureEnabled && isDeviceOwner) {
					<ng-container *ngTemplateOutlet="codeGenerateTabs"></ng-container>
				}
				@if (isHaspCodeGenFeatureEnabled && !isDeviceOwner) {
					@if (allowAccessCodeGen && allowHaspCodeGen) {
						@if (
							!fromDeviceScreen &&
							hasValidDeviceSelected() &&
							!(
								this.fetchingDeviceControlSummaries ||
								(this.resultingDeviceAccess?.length ?? 0) === 0 ||
								this.resultingDeviceAccess
							)
						) {
							<mat-divider></mat-divider>
						}
						@if (!isPDQDevice && !isSentriVaultDeviceFlag) {
							<div class="bottom-spacing-32" id="code-tabs">
								<mat-tab-group
									#codeGenTabGroup
									id="code-gen-tab"
									class="remove-border-bottom"
									mat-stretch-tabs
									(selectedTabChange)="onTabChanged($event)"
									[(selectedIndex)]="codeGenTabIndex"
								>
									<div class="row">
										<mat-tab (click)="isOneDayCodeDisabled()" label="access-code">
											<ng-template mat-tab-label>
												@if (isHaspCodeGenForm) {
													<div class="icon-container column">
														<mat-icon svgIcon="sl-access-code-gen"></mat-icon>
														<p class="tab-icon-text tab-text" i18n="@@deviceGenerateOneDayCode-accessCodeTab">
															Access Code
														</p>
													</div>
												}
												@if (!isHaspCodeGenForm) {
													<div class="icon-container column">
														<mat-icon svgIcon="sl-access-code-gen-filled"></mat-icon>
														<p class="tab-icon-text-selected tab-text" i18n="@@deviceGenerateOneDayCode-accessCodeTab">
															Access Code
														</p>
													</div>
												}
											</ng-template>
										</mat-tab>
										<mat-tab (click)="isOneDayCodeDisabled()" label="hasp-code">
											<ng-template mat-tab-label>
												@if (!isHaspCodeGenForm) {
													<div class="icon-container column">
														<mat-icon svgIcon="sl-hasp-code-gen"></mat-icon>
														<p class="tab-icon-text tab-text" i18n="@@deviceGenerateOneDayCode-haspCodeTab">
															Hasp Code
														</p>
													</div>
												}
												@if (isHaspCodeGenForm) {
													<div class="icon-container column">
														<mat-icon svgIcon="sl-hasp-code-gen-filled"></mat-icon>
														<p class="tab-icon-text-selected tab-text" i18n="@@deviceGenerateOneDayCode-haspCodeTab">
															Hasp Code
														</p>
													</div>
												}
											</ng-template>
										</mat-tab>
									</div>
								</mat-tab-group>
							</div>
						}
						@if (isHaspCodeGenForm) {
							<!-- Reason for hasp code generation -->
							<div>
								<div class="sn-lookup-columns">
									<div class="display-flex">
										<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
											<div class="flex-row-space-between">
												<div
													id="hasp-code-generation-label"
													class="drawer-dialog-content-header large-title-formatting"
													i18n="@@deviceGenerateCodeDialog-codeGeneration"
												>
													Code Generation
												</div>
											</div>
											<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
												<mat-label
													class="mat-label-color"
													i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
													data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
													>Reason for Generation</mat-label
												>
												<textarea
													class="text-area-size"
													[required]="reasonRequireForGenerationReasonRequired"
													matInput
													[maxLength]="600"
													[disabled]="!device.id"
													cdkTextareaAutosize
													[cdkAutosizeMinRows]="1"
													[(ngModel)]="oneDayOrFlexCodeEdits.reason"
													(ngModelChange)="isOneDayCodeDisabled()"
													data-automation-id="generate-hasp-code-reason-textarea"
												>
												</textarea>
											</mat-form-field>
										</div>
										@if (fromDeviceScreen && device.deviceGeneration) {
											<div class="margin-left-32" style="line-height: 2.6em">
												@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
													<div>
														<img
															class="lb-img"
															src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
															alt="Gen 4 Lockbox"
															data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
														/>
													</div>
												}
												@if (!device.deviceGeneration.toLowerCase().includes('gen4')) {
													<div>
														<img
															class="lb-img"
															src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
															alt="Gen 3 Lockbox"
															data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
														/>
													</div>
												}
											</div>
										}
									</div>
								</div>
							</div>
							<mat-divider></mat-divider>
							<!-- New device location for hasp code generation -->
							<div>
								<div class="row row-between margin-bottom-8">
									<div class="property-text-container">
										<p i18n="@@deviceGenerateOneDayCode-removeFromPropertyPrompt">
											Will the device be removed from the property?
										</p>
									</div>
									<div>
										<mat-button-toggle-group
											class="remove-from-property-toggle"
											[value]="true"
											[hideSingleSelectionIndicator]="true"
										>
											<mat-button-toggle
												[value]="false"
												(change)="onRemoveToggle($event.value)"
												data-automation-id="remove-from-property-no-toggle"
												i18n="@@deviceGenerateOneDayCode-removePropertyNoToggle"
												>No
											</mat-button-toggle>
											<mat-button-toggle
												[value]="true"
												(change)="onRemoveToggle($event.value)"
												data-automation-id="remove-from-property-yes-toggle"
												i18n="@@deviceGenerateOneDayCode-removePropertyYesToggle"
												>Yes
											</mat-button-toggle>
										</mat-button-toggle-group>
									</div>
								</div>
								@if (!willRemoveFromProperty) {
									<div id="new-location-box" class="column display-flex">
										<div class="row">
											<div
												id="hasp-code-generation-label"
												class="drawer-dialog-content-header large-title-formatting"
												i18n="@@deviceGenerateCodeDialog-newLocationTitle"
											>
												New Device Location
											</div>
											<p
												class="spacing-left new-location-optional"
												i18n="@@deviceGenerateCodeDialog-newLocationOptionalCaps"
											>
												(Optional)
											</p>
										</div>
										<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
											<textarea
												class="text-area-size"
												matInput
												[maxLength]="600"
												[disabled]="!device.id"
												cdkTextareaAutosize
												[cdkAutosizeMinRows]="1"
												[(ngModel)]="oneDayOrFlexCodeEdits.newLocation"
												(ngModelChange)="isOneDayCodeDisabled()"
												data-automation-id="generate-hasp-code-new-location-textarea"
												[placeholder]="newLocationPlaceholder"
											></textarea>
										</mat-form-field>
										<mat-divider></mat-divider>
									</div>
								}
							</div>
							<!-- Date valid for hasp code generation -->
							@if (device.id) {
								<div>
									<div class="flex-row-space-between">
										<div
											class="drawer-dialog-content-header large-title-formatting"
											i18n="@@deviceGenerateOneDayCode-dateValidTitle"
										>
											Date Valid
										</div>
										<span class="asterisk-text">*</span>
									</div>
									<div class="take-full-width spacing-column-16">
										<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
											<input
												required
												matInput
												[formControl]="dateTimeControl"
												[disabled]="!device.id"
												[min]="minStartDate"
												[max]="maxStartDate"
												[matDatepicker]="picker"
												[matDatepickerFilter]="myFilter"
												[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
												(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
												(ngModelChange)="transformValidDate($event)"
												data-automation-id="start-datepicker-input"
											/>
											<mat-datepicker-toggle
												matSuffix
												class="date-picker-primary-blue"
												[for]="picker"
												data-automation-id="start-datepicker-toggle"
											>
												<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
											</mat-datepicker-toggle>
											<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
										</mat-form-field>
										<div class="column"></div>
									</div>
								</div>
							}
							<mat-divider></mat-divider>
							<!-- Contact form for hasp code generation -->
							<div class="flex-row-space-between">
								<div
									class="drawer-dialog-content-header large-title-formatting"
									i18n="@@deviceGenerateOneDayCode-assignToTitle"
								>
									Assign To
								</div>
							</div>
							<div class="column">
								<div class="column take-full-width">
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="margin-bottom-16"
										style="width: 100%"
									>
										<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName"
											>First Name</mat-label
										>
										<input
											required
											matInput
											[disabled]="!device.id"
											[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
											(ngModelChange)="isOneDayCodeDisabled()"
											data-automation-id="first-name-input"
										/>
									</mat-form-field>
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="margin-bottom-16"
										style="width: 100%"
									>
										<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName">Last Name</mat-label>
										<input
											required
											matInput
											[disabled]="!device.id"
											[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
											(ngModelChange)="isOneDayCodeDisabled()"
											data-automation-id="last-name-input"
										/>
									</mat-form-field>
								</div>
								<div class="row take-full-width">
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="margin-bottom-16"
										style="width: 100%"
									>
										<input
											matInput
											[disabled]="!device.id"
											[(ngModel)]="oneDayOrFlexCodeEdits.email"
											(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
											data-automation-id="email-input"
											[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
											class="email-input-field"
										/>
									</mat-form-field>
									<div class="margin-bottom-16" style="width: 100%">
										<app-contact-phone-type-form
											class="new-mobile-form-width"
											[isDisabled]="!device.id"
											[existingPhoneNumber]="mobilePhone"
											(userPhoneNumber)="updateUserPhone($event)"
											[optional]="true"
										>
										</app-contact-phone-type-form>
									</div>
								</div>
							</div>
							@if (isWallMountDevice) {
								<div class="wall-mount-no-hasp-gen-message-container">
									<mat-icon svgIcon="sl-danger-triangle"></mat-icon>
									<span class="wall-mount-no-hasp-gen-message" i18n="@@deviceGenerateOneDayCode-wallMountNoHaspGen">
										Wall-mounted devices cannot generate hasp codes.
									</span>
								</div>
							}
						} @else {
							@if (!!device.id) {
								<div>
									<div class="sn-lookup-columns">
										<div class="display-flex">
											<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
												<!-- Reason for code generation input field -->
												<div class="flex-row-space-between">
													<div
														id="access-code-generation-label"
														class="drawer-dialog-content-header large-title-formatting"
														i18n="@@deviceGenerateCodeDialog-codeGeneration"
													>
														Code Generation
													</div>
												</div>
												<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
													<mat-label
														class="mat-label-color"
														i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
														data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
														>Reason for Generation</mat-label
													>
													<textarea
														class="text-area-size"
														[required]="reasonRequireForGenerationReasonRequired"
														matInput
														[maxLength]="600"
														[disabled]="!device.id"
														cdkTextareaAutosize
														[cdkAutosizeMinRows]="1"
														[(ngModel)]="oneDayOrFlexCodeEdits.reason"
														(ngModelChange)="isOneDayCodeDisabled()"
														data-automation-id="generate-access-code-textarea"
													>
													</textarea>
												</mat-form-field>
											</div>
											<!-- Device generation icon visible if coming from device screen -->
											@if (fromDeviceScreen && device.deviceGeneration) {
												<div class="margin-left-32" style="line-height: 2.6em">
													@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
														<div>
															<img
																class="lb-img"
																src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
																alt="Gen 4 Lockbox"
																data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
															/>
														</div>
													}
													@if (device.deviceGeneration.toLowerCase().includes('gen3')) {
														<div>
															<img
																class="lb-img"
																src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
																alt="Gen 3 Lockbox"
																data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
															/>
														</div>
													}
													@if (device.deviceGeneration.includes(PDQ_KMS_GENERATION_1)) {
														<div>
															<img
																class="lb-img kms-lockset-img"
																src="${environment.deployPath}/../assets/icons/senturian-1-kms.png"
																alt="Senturian Series Deadbolt"
																data-automation-id="deviceGenerateCodeDialog-santurianSeriesDeadboltDeviceImage"
															/>
														</div>
													}
													@if (device.deviceGeneration.includes(PDQ_SDS_GENERATION_1)) {
														<div>
															<img
																class="lb-img sds-lockset-img"
																src="${environment.deployPath}/../assets/icons/senturian-1-sds.png"
																alt="Senturian Series Cylindrical"
																data-automation-id="deviceGenerateCodeDialog-santurianSeriesCylindricalDeviceImage"
															/>
														</div>
													}
													<!-- Added for the Sentri-Vault image based on conditionally : -->
													@if (isSentriVaultDeviceFlag) {
														<div>
															<img
																class="lb-img sds-lockset-img"
																src="${environment.deployPath}/../assets/icons/sentrivault.png"
																alt="SentriVault"
																data-automation-id="deviceGenerateCodeDialog-sentrivaultDeviceImage"
															/>
														</div>
													}
												</div>
											}
										</div>
									</div>
								</div>
								<mat-divider></mat-divider>
								@if (device.deviceGeneration) {
									<div>
										@if (showStartAndEndDateTimeframe()) {
											<div>
												<div class="timeframe-header">
													<div class="timeframe-title-row">
														<div
															class="drawer-dialog-content-header large-title-formatting margin-bottom-8"
															i18n="@@deviceGenerateOneDayCode-durationTitle"
														>
															Duration
														</div>
														<div class="align-items-start display-flex align-content-end">
															<mat-checkbox
																class="align-items-start row-end display-flex non-overlapping-checkbox"
																[checked]="!oneDayOrFlexCodeEdits.locked"
																[disabled]="!device.id"
																(change)="oneDayOrFlexCodeEdits.locked = !oneDayOrFlexCodeEdits.locked"
																i18n="@@deviceGenerateOneDayCode-nonOverlappingCheckbox"
																data-automation-id="non-overlapping-checkbox"
																>Non-Overlapping</mat-checkbox
															>
															<mat-icon
																class="tooltip-icon mobile-tooltip-icon"
																svgIcon="sl-info-circle"
																[matTooltip]="nonOverlappingTooltip"
																matTooltipClass="mobile-tooltip"
																(click)="$event.stopPropagation()"
																(touchend)="$event.stopPropagation()"
																[attr.aria-label]="nonOverlappingTooltip"
																role="button"
																tabindex="0"
															>
															</mat-icon>
														</div>
													</div>
													<div class="content-sub-title" i18n="@@deviceGenerateOneDayCode-timezoneBasedOnLocation">
														Time zone based on device location
													</div>
												</div>
												<!-- Multi-day hour timeframe for non-hasp code generation -->
												<div class="date-time-container">
													<div class="column-double">
														<div class="flex-row-space-between">
															<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startDateTitle">
																Start Date
															</div>
															<span class="asterisk-text">*</span>
														</div>
														<mat-form-field
															subscriptSizing="dynamic"
															appearance="outline"
															class="placeholder-text-style"
														>
															<input
																required
																matInput
																[formControl]="dateTimeControl"
																[disabled]="!device.id"
																[min]="minStartDate"
																[max]="maxStartDate"
																[matDatepicker]="startDatePicker"
																[matDatepickerFilter]="myFilter"
																[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
																(ngModel)="(this.oneDayOrFlexCodeEdits.startDate)"
																(ngModelChange)="transformStartDate($event)"
																data-automation-id="start-datepicker-input"
															/>
															<mat-datepicker-toggle
																matSuffix
																[for]="startDatePicker"
																data-automation-id="start-datepicker-toggle"
															>
																<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
															</mat-datepicker-toggle>
															<mat-datepicker #startDatePicker data-automation-id="start-datepicker"></mat-datepicker>
															@if (dateTimeControl.hasError('required')) {
																<mat-error
																	i18n-placeholder="@@deviceGenerateCodeDialog-startDateError"
																	data-automation-id="start-datepicker-error"
																	>Make sure to select a valid Start Date</mat-error
																>
															}
														</mat-form-field>
													</div>
													<div class="column">
														<div class="flex-row-space-between">
															<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startTimeTitle">
																Start Time
															</div>
															<span class="asterisk-text">*</span>
														</div>
														<app-military-time-picker
															class="select-border"
															[passedInTime]="this.oneDayOrFlexCodeEdits.startTime"
															[endTimeMustBeAfter]="startTimeMustBeAfter"
															[endTimeMustBeBefore]="startTimeMustBeBefore"
															(onTimeSelected)="onStartTimeSelected($event)"
															data-automation-id="start-date-military-time-picker"
														>
														</app-military-time-picker>
													</div>
												</div>
												<div class="date-time-container">
													<div class="column-double">
														<div class="flex-row-space-between">
															<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endDateTitle">
																End Date
															</div>
															<span class="asterisk-text">*</span>
														</div>
														<mat-form-field subscriptSizing="dynamic" appearance="outline">
															<input
																required
																matInput
																#endDateInput
																[formControl]="endDateTimeControl"
																[disabled]="!device.id"
																[min]="minEndDate"
																[max]="maxEndDate"
																[matDatepicker]="endDatePicker"
																[matDatepickerFilter]="myFilter"
																[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
																(ngModel)="(this.oneDayOrFlexCodeEdits.endDate)"
																(ngModelChange)="transformEndDate($event)"
																data-automation-id="end-datepicker-input"
															/>
															<mat-datepicker-toggle
																matSuffix
																class="date-picker-primary-blue"
																[for]="endDatePicker"
																data-automation-id="end-datepicker-toggle"
															>
																<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
															</mat-datepicker-toggle>
															<mat-datepicker #endDatePicker data-automation-id="end-datepicker"></mat-datepicker>
															@if (endDateTimeControl.hasError('required')) {
																<mat-error
																	i18n-placeholder="@@deviceGenerateCodeDialog-endDateError"
																	data-automation-id="end-datepicker-error"
																	>Make sure to select a valid End Date</mat-error
																>
															}
														</mat-form-field>
													</div>
													<div class="column">
														<div class="flex-row-space-between">
															<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endTimeTitle">
																End Time
															</div>
															<span class="asterisk-text">*</span>
														</div>
														<app-military-time-picker
															class="select-border"
															[passedInTime]="this.oneDayOrFlexCodeEdits.endTime"
															[endTimeMustBeAfter]="endTimeMustBeAfter"
															[endTimeMustBeBefore]="endTimeMustBeBefore"
															(onTimeSelected)="onEndTimeSelected($event)"
															data-automation-id="end-date-military-time-picker"
														>
														</app-military-time-picker>
													</div>
												</div>
											</div>
										}
										<!-- Single day date valid for non-hasp code generation -->
										@if (!showStartAndEndDateTimeframe()) {
											<div>
												<div class="flex-row-space-between">
													<div
														class="drawer-dialog-content-header large-title-formatting"
														i18n="@@deviceGenerateOneDayCode-dateValidTitle"
													>
														Date Valid
													</div>
													<span class="asterisk-text">*</span>
												</div>
												<div class="take-full-width spacing-column-16">
													<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
														<input
															required
															matInput
															[formControl]="dateTimeControl"
															[disabled]="!device.id"
															[min]="minStartDate"
															[max]="maxStartDate"
															[matDatepicker]="picker"
															[matDatepickerFilter]="myFilter"
															[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
															(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
															(ngModelChange)="transformValidDate($event)"
															data-automation-id="start-datepicker-input"
														/>
														<mat-datepicker-toggle
															matSuffix
															class="date-picker-primary-blue"
															[for]="picker"
															data-automation-id="start-datepicker-toggle"
														>
															<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
														</mat-datepicker-toggle>
														<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
													</mat-form-field>
													<div class="column"></div>
												</div>
											</div>
										}
									</div>
								}
								<mat-divider></mat-divider>
								<!-- Contact form for non-hasp code generation -->
								<div class="flex-row-space-between">
									<div
										class="drawer-dialog-content-header large-title-formatting"
										i18n="@@deviceGenerateOneDayCode-assignToTitle"
									>
										Assign To
									</div>
								</div>
								<div class="column">
									<div class="column take-full-width">
										<mat-form-field
											subscriptSizing="dynamic"
											appearance="outline"
											class="margin-bottom-16"
											style="width: 100%"
										>
											<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName"
												>First Name</mat-label
											>
											<input
												required
												matInput
												[disabled]="!device.id"
												[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
												(ngModelChange)="isOneDayCodeDisabled()"
												data-automation-id="first-name-input"
											/>
										</mat-form-field>
										<mat-form-field
											subscriptSizing="dynamic"
											appearance="outline"
											class="margin-bottom-16"
											style="width: 100%"
										>
											<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName"
												>Last Name</mat-label
											>
											<input
												required
												matInput
												[disabled]="!device.id"
												[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
												(ngModelChange)="isOneDayCodeDisabled()"
												data-automation-id="last-name-input"
											/>
										</mat-form-field>
									</div>
									<div class="row take-full-width">
										<mat-form-field
											subscriptSizing="dynamic"
											appearance="outline"
											class="margin-bottom-16"
											style="width: 100%"
										>
											<input
												matInput
												[disabled]="!device.id"
												[(ngModel)]="oneDayOrFlexCodeEdits.email"
												(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
												data-automation-id="email-input"
												[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
												class="email-input-field"
											/>
										</mat-form-field>
										<div class="margin-bottom-16" style="width: 100%">
											<app-contact-phone-type-form
												class="new-mobile-form-width"
												[isDisabled]="!device.id"
												[existingPhoneNumber]="mobilePhone"
												(userPhoneNumber)="updateUserPhone($event)"
												[optional]="true"
											>
											</app-contact-phone-type-form>
										</div>
									</div>
								</div>
							}
						}
					}
					@if (allowAccessCodeGen && !allowHaspCodeGen) {
						@if (!!device.id) {
							<div>
								<div class="sn-lookup-columns">
									<div class="display-flex">
										<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
											<!-- Reason for code generation input field -->
											<div class="flex-row-space-between">
												<div
													id="access-code-generation-label"
													class="drawer-dialog-content-header large-title-formatting"
													i18n="@@deviceGenerateCodeDialog-codeGeneration"
												>
													Code Generation
												</div>
											</div>
											<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
												<mat-label
													class="mat-label-color"
													i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
													data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
													>Reason for Generation</mat-label
												>
												<textarea
													class="text-area-size"
													[required]="reasonRequireForGenerationReasonRequired"
													matInput
													[maxLength]="600"
													[disabled]="!device.id"
													cdkTextareaAutosize
													[cdkAutosizeMinRows]="1"
													[(ngModel)]="oneDayOrFlexCodeEdits.reason"
													(ngModelChange)="isOneDayCodeDisabled()"
													data-automation-id="generate-access-code-textarea"
												>
												</textarea>
											</mat-form-field>
										</div>
										<!-- Device generation icon visible if coming from device screen -->
										@if (fromDeviceScreen && device.deviceGeneration) {
											<div class="margin-left-32" style="line-height: 2.6em">
												@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
													<div>
														<img
															class="lb-img"
															src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
															alt="Gen 4 Lockbox"
															data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
														/>
													</div>
												}
												@if (device.deviceGeneration.toLowerCase().includes('gen3')) {
													<div>
														<img
															class="lb-img"
															src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
															alt="Gen 3 Lockbox"
															data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
														/>
													</div>
												}
												@if (device.deviceGeneration.includes(PDQ_KMS_GENERATION_1)) {
													<div>
														<img
															class="lb-img kms-lockset-img"
															src="${environment.deployPath}/../assets/icons/senturian-1-kms.png"
															alt="Senturian Series Deadbolt"
															data-automation-id="deviceGenerateCodeDialog-santurianSeriesDeadboltDeviceImage"
														/>
													</div>
												}
												@if (device.deviceGeneration.includes(PDQ_SDS_GENERATION_1)) {
													<div>
														<img
															class="lb-img sds-lockset-img"
															src="${environment.deployPath}/../assets/icons/senturian-1-sds.png"
															alt="Senturian Series Cylindrical"
															data-automation-id="deviceGenerateCodeDialog-santurianSeriesCylindricalDeviceImage"
														/>
													</div>
												}
												<!-- Added for the Sentri-Vault image based on conditionally : -->
												@if (isSentriVaultDeviceFlag) {
													<div>
														<img
															class="lb-img sds-lockset-img"
															src="${environment.deployPath}/../assets/icons/sentrivault.png"
															alt="SentriVault"
															data-automation-id="deviceGenerateCodeDialog-sentrivaultDeviceImage"
														/>
													</div>
												}
											</div>
										}
									</div>
								</div>
							</div>
							<mat-divider></mat-divider>
							@if (device.deviceGeneration) {
								<div>
									@if (showStartAndEndDateTimeframe()) {
										<div>
											<div class="timeframe-header">
												<div class="timeframe-title-row">
													<div
														class="drawer-dialog-content-header large-title-formatting margin-bottom-8"
														i18n="@@deviceGenerateOneDayCode-durationTitle"
													>
														Duration
													</div>
													<div class="align-items-start display-flex align-content-end">
														<mat-checkbox
															class="align-items-start row-end display-flex non-overlapping-checkbox"
															[checked]="!oneDayOrFlexCodeEdits.locked"
															[disabled]="!device.id"
															(change)="oneDayOrFlexCodeEdits.locked = !oneDayOrFlexCodeEdits.locked"
															i18n="@@deviceGenerateOneDayCode-nonOverlappingCheckbox"
															data-automation-id="non-overlapping-checkbox"
															>Non-Overlapping</mat-checkbox
														>
														<mat-icon
															class="tooltip-icon mobile-tooltip-icon"
															svgIcon="sl-info-circle"
															[matTooltip]="nonOverlappingTooltip"
															matTooltipClass="mobile-tooltip"
															(click)="$event.stopPropagation()"
															(touchend)="$event.stopPropagation()"
															[attr.aria-label]="nonOverlappingTooltip"
															role="button"
															tabindex="0"
														>
														</mat-icon>
													</div>
												</div>
												<div class="content-sub-title" i18n="@@deviceGenerateOneDayCode-timezoneBasedOnLocation">
													Time zone based on device location
												</div>
											</div>
											<!-- Multi-day hour timeframe for non-hasp code generation -->
											<div class="date-time-container">
												<div class="column-double">
													<div class="flex-row-space-between">
														<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startDateTitle">
															Start Date
														</div>
														<span class="asterisk-text">*</span>
													</div>
													<mat-form-field subscriptSizing="dynamic" appearance="outline" class="placeholder-text-style">
														<input
															required
															matInput
															[formControl]="dateTimeControl"
															[disabled]="!device.id"
															[min]="minStartDate"
															[max]="maxStartDate"
															[matDatepicker]="startDatePicker"
															[matDatepickerFilter]="myFilter"
															[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
															(ngModel)="(this.oneDayOrFlexCodeEdits.startDate)"
															(ngModelChange)="transformStartDate($event)"
															data-automation-id="start-datepicker-input"
														/>
														<mat-datepicker-toggle
															matSuffix
															[for]="startDatePicker"
															data-automation-id="start-datepicker-toggle"
														>
															<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
														</mat-datepicker-toggle>
														<mat-datepicker #startDatePicker data-automation-id="start-datepicker"></mat-datepicker>
														@if (dateTimeControl.hasError('required')) {
															<mat-error
																i18n-placeholder="@@deviceGenerateCodeDialog-startDateError"
																data-automation-id="start-datepicker-error"
																>Make sure to select a valid Start Date</mat-error
															>
														}
													</mat-form-field>
												</div>
												<div class="column">
													<div class="flex-row-space-between">
														<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startTimeTitle">
															Start Time
														</div>
														<span class="asterisk-text">*</span>
													</div>
													<app-military-time-picker
														class="select-border"
														[passedInTime]="this.oneDayOrFlexCodeEdits.startTime"
														[endTimeMustBeAfter]="startTimeMustBeAfter"
														[endTimeMustBeBefore]="startTimeMustBeBefore"
														(onTimeSelected)="onStartTimeSelected($event)"
														data-automation-id="start-date-military-time-picker"
													>
													</app-military-time-picker>
												</div>
											</div>
											<div class="date-time-container">
												<div class="column-double">
													<div class="flex-row-space-between">
														<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endDateTitle">
															End Date
														</div>
														<span class="asterisk-text">*</span>
													</div>
													<mat-form-field subscriptSizing="dynamic" appearance="outline">
														<input
															required
															matInput
															#endDateInput
															[formControl]="endDateTimeControl"
															[disabled]="!device.id"
															[min]="minEndDate"
															[max]="maxEndDate"
															[matDatepicker]="endDatePicker"
															[matDatepickerFilter]="myFilter"
															[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
															(ngModel)="(this.oneDayOrFlexCodeEdits.endDate)"
															(ngModelChange)="transformEndDate($event)"
															data-automation-id="end-datepicker-input"
														/>
														<mat-datepicker-toggle
															matSuffix
															class="date-picker-primary-blue"
															[for]="endDatePicker"
															data-automation-id="end-datepicker-toggle"
														>
															<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
														</mat-datepicker-toggle>
														<mat-datepicker #endDatePicker data-automation-id="end-datepicker"></mat-datepicker>
														@if (endDateTimeControl.hasError('required')) {
															<mat-error
																i18n-placeholder="@@deviceGenerateCodeDialog-endDateError"
																data-automation-id="end-datepicker-error"
																>Make sure to select a valid End Date</mat-error
															>
														}
													</mat-form-field>
												</div>
												<div class="column">
													<div class="flex-row-space-between">
														<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endTimeTitle">
															End Time
														</div>
														<span class="asterisk-text">*</span>
													</div>
													<app-military-time-picker
														class="select-border"
														[passedInTime]="this.oneDayOrFlexCodeEdits.endTime"
														[endTimeMustBeAfter]="endTimeMustBeAfter"
														[endTimeMustBeBefore]="endTimeMustBeBefore"
														(onTimeSelected)="onEndTimeSelected($event)"
														data-automation-id="end-date-military-time-picker"
													>
													</app-military-time-picker>
												</div>
											</div>
										</div>
									}
									<!-- Single day date valid for non-hasp code generation -->
									@if (!showStartAndEndDateTimeframe()) {
										<div>
											<div class="flex-row-space-between">
												<div
													class="drawer-dialog-content-header large-title-formatting"
													i18n="@@deviceGenerateOneDayCode-dateValidTitle"
												>
													Date Valid
												</div>
												<span class="asterisk-text">*</span>
											</div>
											<div class="take-full-width spacing-column-16">
												<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
													<input
														required
														matInput
														[formControl]="dateTimeControl"
														[disabled]="!device.id"
														[min]="minStartDate"
														[max]="maxStartDate"
														[matDatepicker]="picker"
														[matDatepickerFilter]="myFilter"
														[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
														(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
														(ngModelChange)="transformValidDate($event)"
														data-automation-id="start-datepicker-input"
													/>
													<mat-datepicker-toggle
														matSuffix
														class="date-picker-primary-blue"
														[for]="picker"
														data-automation-id="start-datepicker-toggle"
													>
														<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
													</mat-datepicker-toggle>
													<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
												</mat-form-field>
												<div class="column"></div>
											</div>
										</div>
									}
								</div>
							}
							<mat-divider></mat-divider>
							<!-- Contact form for non-hasp code generation -->
							<div class="flex-row-space-between">
								<div
									class="drawer-dialog-content-header large-title-formatting"
									i18n="@@deviceGenerateOneDayCode-assignToTitle"
								>
									Assign To
								</div>
							</div>
							<div class="column">
								<div class="column take-full-width">
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="margin-bottom-16"
										style="width: 100%"
									>
										<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName"
											>First Name</mat-label
										>
										<input
											required
											matInput
											[disabled]="!device.id"
											[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
											(ngModelChange)="isOneDayCodeDisabled()"
											data-automation-id="first-name-input"
										/>
									</mat-form-field>
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="margin-bottom-16"
										style="width: 100%"
									>
										<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName">Last Name</mat-label>
										<input
											required
											matInput
											[disabled]="!device.id"
											[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
											(ngModelChange)="isOneDayCodeDisabled()"
											data-automation-id="last-name-input"
										/>
									</mat-form-field>
								</div>
								<div class="row take-full-width">
									<mat-form-field
										subscriptSizing="dynamic"
										appearance="outline"
										class="margin-bottom-16"
										style="width: 100%"
									>
										<input
											matInput
											[disabled]="!device.id"
											[(ngModel)]="oneDayOrFlexCodeEdits.email"
											(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
											data-automation-id="email-input"
											[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
											class="email-input-field"
										/>
									</mat-form-field>
									<div class="margin-bottom-16" style="width: 100%">
										<app-contact-phone-type-form
											class="new-mobile-form-width"
											[isDisabled]="!device.id"
											[existingPhoneNumber]="mobilePhone"
											(userPhoneNumber)="updateUserPhone($event)"
											[optional]="true"
										>
										</app-contact-phone-type-form>
									</div>
								</div>
							</div>
						}
					}
					@if (!allowAccessCodeGen && allowHaspCodeGen) {
						<!-- Reason for hasp code generation -->
						<div>
							<div class="sn-lookup-columns">
								<div class="display-flex">
									<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
										<div class="flex-row-space-between">
											<div
												id="hasp-code-generation-label"
												class="drawer-dialog-content-header large-title-formatting"
												i18n="@@deviceGenerateCodeDialog-codeGeneration"
											>
												Code Generation
											</div>
											@if (reasonRequireForGenerationReasonRequired) {
												<span
													class="asterisk-text"
													data-automation-id="deviceGenerateCodeDialog-codeGeneration-required"
													>*</span
												>
											}
										</div>
										<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
											<mat-label
												class="mat-label-color"
												i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
												data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
												>Reason for Generation</mat-label
											>
											<textarea
												class="text-area-size"
												[required]="reasonRequireForGenerationReasonRequired"
												matInput
												[maxLength]="600"
												[disabled]="!device.id"
												cdkTextareaAutosize
												[cdkAutosizeMinRows]="1"
												[(ngModel)]="oneDayOrFlexCodeEdits.reason"
												(ngModelChange)="isOneDayCodeDisabled()"
												data-automation-id="generate-hasp-code-reason-textarea"
											>
											</textarea>
										</mat-form-field>
									</div>
									@if (fromDeviceScreen && device.deviceGeneration) {
										<div class="margin-left-32" style="line-height: 2.6em">
											@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
												<div>
													<img
														class="lb-img"
														src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
														alt="Gen 4 Lockbox"
														data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
													/>
												</div>
											}
											@if (!device.deviceGeneration.toLowerCase().includes('gen4')) {
												<div>
													<img
														class="lb-img"
														src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
														alt="Gen 3 Lockbox"
														data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
													/>
												</div>
											}
										</div>
									}
								</div>
							</div>
						</div>
						<mat-divider></mat-divider>
						<!-- New device location for hasp code generation -->
						<div>
							<div class="row row-between margin-bottom-8">
								<div class="property-text-container">
									<p i18n="@@deviceGenerateOneDayCode-removeFromPropertyPrompt">
										Will the device be removed from the property?
									</p>
								</div>
								<div>
									<mat-button-toggle-group
										class="remove-from-property-toggle"
										[value]="true"
										[hideSingleSelectionIndicator]="true"
									>
										<mat-button-toggle
											[value]="false"
											(change)="onRemoveToggle($event.value)"
											data-automation-id="remove-from-property-no-toggle"
											i18n="@@deviceGenerateOneDayCode-removePropertyNoToggle"
											>No
										</mat-button-toggle>
										<mat-button-toggle
											[value]="true"
											(change)="onRemoveToggle($event.value)"
											data-automation-id="remove-from-property-yes-toggle"
											i18n="@@deviceGenerateOneDayCode-removePropertyYesToggle"
											>Yes
										</mat-button-toggle>
									</mat-button-toggle-group>
								</div>
							</div>
							@if (!willRemoveFromProperty) {
								<div id="new-location-box" class="column display-flex">
									<div class="row">
										<div
											id="hasp-code-generation-label"
											class="drawer-dialog-content-header large-title-formatting"
											i18n="@@deviceGenerateCodeDialog-newLocationTitle"
										>
											New Device Location
										</div>
										<p
											class="spacing-left new-location-optional"
											i18n="@@deviceGenerateCodeDialog-newLocationOptionalCaps"
										>
											(Optional)
										</p>
									</div>
									<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
										<textarea
											class="text-area-size"
											matInput
											[maxLength]="600"
											[disabled]="!device.id"
											cdkTextareaAutosize
											[cdkAutosizeMinRows]="1"
											[(ngModel)]="oneDayOrFlexCodeEdits.newLocation"
											(ngModelChange)="isOneDayCodeDisabled()"
											data-automation-id="generate-hasp-code-new-location-textarea"
											[placeholder]="newLocationPlaceholder"
										></textarea>
									</mat-form-field>
									<mat-divider></mat-divider>
								</div>
							}
						</div>
						<!-- Date valid for hasp code generation -->
						@if (device.id) {
							<div>
								<div class="flex-row-space-between">
									<div
										class="drawer-dialog-content-header large-title-formatting"
										i18n="@@deviceGenerateOneDayCode-dateValidTitle"
									>
										Date Valid
									</div>
									<span class="asterisk-text">*</span>
								</div>
								<div class="take-full-width spacing-column-16">
									<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
										<input
											required
											matInput
											[formControl]="dateTimeControl"
											[disabled]="!device.id"
											[min]="minStartDate"
											[max]="maxStartDate"
											[matDatepicker]="picker"
											[matDatepickerFilter]="myFilter"
											[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
											(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
											(ngModelChange)="transformValidDate($event)"
											data-automation-id="start-datepicker-input"
										/>
										<mat-datepicker-toggle
											matSuffix
											class="date-picker-primary-blue"
											[for]="picker"
											data-automation-id="start-datepicker-toggle"
										>
											<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
									</mat-form-field>
									<div class="column"></div>
								</div>
							</div>
						}
						<mat-divider></mat-divider>
						<!-- Contact form for hasp code generation -->
						<div class="flex-row-space-between">
							<div
								class="drawer-dialog-content-header large-title-formatting"
								i18n="@@deviceGenerateOneDayCode-assignToTitle"
							>
								Assign To
							</div>
						</div>
						<div class="column">
							<div class="column take-full-width">
								<mat-form-field
									subscriptSizing="dynamic"
									appearance="outline"
									class="margin-bottom-16"
									style="width: 100%"
								>
									<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName">First Name</mat-label>
									<input
										required
										matInput
										[disabled]="!device.id"
										[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
										(ngModelChange)="isOneDayCodeDisabled()"
										data-automation-id="first-name-input"
									/>
								</mat-form-field>
								<mat-form-field
									subscriptSizing="dynamic"
									appearance="outline"
									class="margin-bottom-16"
									style="width: 100%"
								>
									<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName">Last Name</mat-label>
									<input
										required
										matInput
										[disabled]="!device.id"
										[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
										(ngModelChange)="isOneDayCodeDisabled()"
										data-automation-id="last-name-input"
									/>
								</mat-form-field>
							</div>
							<div class="row take-full-width">
								<mat-form-field
									subscriptSizing="dynamic"
									appearance="outline"
									class="margin-bottom-16"
									style="width: 100%"
								>
									<input
										matInput
										[disabled]="!device.id"
										[(ngModel)]="oneDayOrFlexCodeEdits.email"
										(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
										data-automation-id="email-input"
										[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
										class="email-input-field"
									/>
								</mat-form-field>
								<div class="margin-bottom-16" style="width: 100%">
									<app-contact-phone-type-form
										class="new-mobile-form-width"
										[isDisabled]="!device.id"
										[existingPhoneNumber]="mobilePhone"
										(userPhoneNumber)="updateUserPhone($event)"
										[optional]="true"
									>
									</app-contact-phone-type-form>
								</div>
							</div>
						</div>
						@if (isWallMountDevice) {
							<div class="wall-mount-no-hasp-gen-message-container">
								<mat-icon svgIcon="sl-danger-triangle"></mat-icon>
								<span class="wall-mount-no-hasp-gen-message" i18n="@@deviceGenerateOneDayCode-wallMountNoHaspGen">
									Wall-mounted devices cannot generate hasp codes.
								</span>
							</div>
						}
					}
					@if (!allowAccessCodeGen && allowHaspCodeGen && isWallMountDevice) {
						<div class="wall-mount-no-hasp-gen-message-container">
							<mat-icon svgIcon="sl-danger-triangle"></mat-icon>
							<span class="wall-mount-no-hasp-gen-message" i18n="@@deviceGenerateOneDayCode-wallMountNoHaspGen">
								Wall-mounted devices cannot generate hasp codes.
							</span>
						</div>
					}
				}
				@if (!isHaspCodeGenFeatureEnabled) {
					<ng-container *ngTemplateOutlet="accessGenerateCode"></ng-container>
				}
			</mat-dialog-content>
		}
	}

	<ng-template #accessGenerateCode>
		@if (!!device.id) {
			<div>
				<div class="sn-lookup-columns">
					<div class="display-flex">
						<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
							<!-- Reason for code generation input field -->
							<div class="flex-row-space-between">
								<div
									id="access-code-generation-label"
									class="drawer-dialog-content-header large-title-formatting"
									i18n="@@deviceGenerateCodeDialog-codeGeneration"
									data-automation-id="deviceGenerateCodeDialog-codeGeneration"
								>
									Code Generation
								</div>
							</div>
							<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
								<mat-label
									class="mat-label-color"
									i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
									data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
									>Reason for Generation</mat-label
								>
								<textarea
									class="text-area-size"
									[required]="reasonRequireForGenerationReasonRequired"
									matInput
									[maxLength]="600"
									[disabled]="!device.id"
									cdkTextareaAutosize
									[cdkAutosizeMinRows]="1"
									[(ngModel)]="oneDayOrFlexCodeEdits.reason"
									(ngModelChange)="isOneDayCodeDisabled()"
									data-automation-id="generate-access-code-textarea"
								>
								</textarea>
							</mat-form-field>
						</div>
						<!-- Device generation icon visible if coming from device screen -->
						@if (fromDeviceScreen && device.deviceGeneration) {
							<div class="margin-left-32" style="line-height: 2.6em">
								@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
									<div>
										<img
											class="lb-img"
											src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
											alt="Gen 4 Lockbox"
											data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
										/>
									</div>
								}
								@if (device.deviceGeneration.toLowerCase().includes('gen3')) {
									<div>
										<img
											class="lb-img"
											src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
											alt="Gen 3 Lockbox"
											data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
										/>
									</div>
								}
								@if (device.deviceGeneration.includes(PDQ_KMS_GENERATION_1)) {
									<div>
										<img
											class="lb-img kms-lockset-img"
											src="${environment.deployPath}/../assets/icons/senturian-1-kms.png"
											alt="Senturian Series Deadbolt"
											data-automation-id="deviceGenerateCodeDialog-santurianSeriesDeadboltDeviceImage"
										/>
									</div>
								}
								@if (device.deviceGeneration.includes(PDQ_SDS_GENERATION_1)) {
									<div>
										<img
											class="lb-img sds-lockset-img"
											src="${environment.deployPath}/../assets/icons/senturian-1-sds.png"
											alt="Senturian Series Cylindrical"
											data-automation-id="deviceGenerateCodeDialog-santurianSeriesCylindricalDeviceImage"
										/>
									</div>
								}
								<!-- Added for the Sentri-Vault image based on conditionally : -->
								@if (isSentriVaultDeviceFlag) {
									<div>
										<img
											class="lb-img sds-lockset-img"
											src="${environment.deployPath}/../assets/icons/sentrivault.png"
											alt="SentriVault"
											data-automation-id="deviceGenerateCodeDialog-sentrivaultDeviceImage"
										/>
									</div>
								}
							</div>
						}
					</div>
				</div>
			</div>
			<mat-divider></mat-divider>
			@if (device.deviceGeneration) {
				<div>
					@if (showStartAndEndDateTimeframe()) {
						<div>
							<div class="timeframe-header">
								<div class="timeframe-title-row">
									<div
										class="drawer-dialog-content-header large-title-formatting margin-bottom-8"
										i18n="@@deviceGenerateOneDayCode-durationTitle"
									>
										Duration
									</div>
									<div class="align-items-start display-flex align-content-end">
										<mat-checkbox
											class="align-items-start row-end display-flex non-overlapping-checkbox"
											[checked]="!oneDayOrFlexCodeEdits.locked"
											[disabled]="!device.id"
											(change)="oneDayOrFlexCodeEdits.locked = !oneDayOrFlexCodeEdits.locked"
											i18n="@@deviceGenerateOneDayCode-nonOverlappingCheckbox"
											data-automation-id="non-overlapping-checkbox"
											>Non-Overlapping</mat-checkbox
										>
										<mat-icon
											class="tooltip-icon mobile-tooltip-icon"
											svgIcon="sl-info-circle"
											[matTooltip]="nonOverlappingTooltip"
											matTooltipClass="mobile-tooltip"
											(click)="$event.stopPropagation()"
											(touchend)="$event.stopPropagation()"
											[attr.aria-label]="nonOverlappingTooltip"
											role="button"
											tabindex="0"
										>
										</mat-icon>
									</div>
								</div>
								<div class="content-sub-title" i18n="@@deviceGenerateOneDayCode-timezoneBasedOnLocation">
									Time zone based on device location
								</div>
							</div>
							<!-- Multi-day hour timeframe for non-hasp code generation -->
							<div class="date-time-container">
								<div class="column-double">
									<div class="flex-row-space-between">
										<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startDateTitle">Start Date</div>
										<span class="asterisk-text">*</span>
									</div>
									<mat-form-field subscriptSizing="dynamic" appearance="outline" class="placeholder-text-style">
										<input
											required
											matInput
											[formControl]="dateTimeControl"
											[disabled]="!device.id"
											[min]="minStartDate"
											[max]="maxStartDate"
											[matDatepicker]="startDatePicker"
											[matDatepickerFilter]="myFilter"
											[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
											(ngModel)="(this.oneDayOrFlexCodeEdits.startDate)"
											(ngModelChange)="transformStartDate($event)"
											data-automation-id="start-datepicker-input"
										/>
										<mat-datepicker-toggle
											matSuffix
											[for]="startDatePicker"
											data-automation-id="start-datepicker-toggle"
										>
											<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker #startDatePicker data-automation-id="start-datepicker"></mat-datepicker>
										@if (dateTimeControl.hasError('required')) {
											<mat-error
												i18n-placeholder="@@deviceGenerateCodeDialog-startDateError"
												data-automation-id="start-datepicker-error"
												>Make sure to select a valid Start Date</mat-error
											>
										}
									</mat-form-field>
								</div>
								<div class="column">
									<div class="flex-row-space-between">
										<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startTimeTitle">Start Time</div>
										<span class="asterisk-text">*</span>
									</div>
									<app-military-time-picker
										class="select-border"
										[passedInTime]="this.oneDayOrFlexCodeEdits.startTime"
										[endTimeMustBeAfter]="startTimeMustBeAfter"
										[endTimeMustBeBefore]="startTimeMustBeBefore"
										(onTimeSelected)="onStartTimeSelected($event)"
										data-automation-id="start-date-military-time-picker"
									>
									</app-military-time-picker>
								</div>
							</div>
							<div class="date-time-container">
								<div class="column-double">
									<div class="flex-row-space-between">
										<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endDateTitle">End Date</div>
										<span class="asterisk-text">*</span>
									</div>
									<mat-form-field subscriptSizing="dynamic" appearance="outline">
										<input
											required
											matInput
											#endDateInput
											[formControl]="endDateTimeControl"
											[disabled]="!device.id"
											[min]="minEndDate"
											[max]="maxEndDate"
											[matDatepicker]="endDatePicker"
											[matDatepickerFilter]="myFilter"
											[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
											(ngModel)="(this.oneDayOrFlexCodeEdits.endDate)"
											(ngModelChange)="transformEndDate($event)"
											data-automation-id="end-datepicker-input"
										/>
										<mat-datepicker-toggle
											matSuffix
											class="date-picker-primary-blue"
											[for]="endDatePicker"
											data-automation-id="end-datepicker-toggle"
										>
											<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker #endDatePicker data-automation-id="end-datepicker"></mat-datepicker>
										@if (endDateTimeControl.hasError('required')) {
											<mat-error
												i18n-placeholder="@@deviceGenerateCodeDialog-endDateError"
												data-automation-id="end-datepicker-error"
												>Make sure to select a valid End Date</mat-error
											>
										}
									</mat-form-field>
								</div>
								<div class="column">
									<div class="flex-row-space-between">
										<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endTimeTitle">End Time</div>
										<span class="asterisk-text">*</span>
									</div>
									<app-military-time-picker
										class="select-border"
										[passedInTime]="this.oneDayOrFlexCodeEdits.endTime"
										[endTimeMustBeAfter]="endTimeMustBeAfter"
										[endTimeMustBeBefore]="endTimeMustBeBefore"
										(onTimeSelected)="onEndTimeSelected($event)"
										data-automation-id="end-date-military-time-picker"
									>
									</app-military-time-picker>
								</div>
							</div>
						</div>
					}
					<!-- Single day date valid for non-hasp code generation -->
					@if (!showStartAndEndDateTimeframe()) {
						<div>
							<div class="flex-row-space-between">
								<div
									class="drawer-dialog-content-header large-title-formatting"
									i18n="@@deviceGenerateOneDayCode-dateValidTitle"
								>
									Date Valid
								</div>
								<span class="asterisk-text">*</span>
							</div>
							<div class="take-full-width spacing-column-16">
								<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
									<input
										required
										matInput
										[formControl]="dateTimeControl"
										[disabled]="!device.id"
										[min]="minStartDate"
										[max]="maxStartDate"
										[matDatepicker]="picker"
										[matDatepickerFilter]="myFilter"
										[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
										(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
										(ngModelChange)="transformValidDate($event)"
										data-automation-id="start-datepicker-input"
									/>
									<mat-datepicker-toggle
										matSuffix
										class="date-picker-primary-blue"
										[for]="picker"
										data-automation-id="start-datepicker-toggle"
									>
										<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
									</mat-datepicker-toggle>
									<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
								</mat-form-field>
								<div class="column"></div>
							</div>
						</div>
					}
				</div>
			}
			<mat-divider></mat-divider>
			<!-- Contact form for non-hasp code generation -->
			<div class="flex-row-space-between">
				<div
					class="drawer-dialog-content-header large-title-formatting"
					i18n="@@deviceGenerateOneDayCode-assignToTitle"
				>
					Assign To
				</div>
			</div>
			<div class="column">
				<div class="column take-full-width">
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
						<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName">First Name</mat-label>
						<input
							required
							matInput
							[disabled]="!device.id"
							[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
							(ngModelChange)="isOneDayCodeDisabled()"
							data-automation-id="first-name-input"
						/>
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
						<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName">Last Name</mat-label>
						<input
							required
							matInput
							[disabled]="!device.id"
							[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
							(ngModelChange)="isOneDayCodeDisabled()"
							data-automation-id="last-name-input"
						/>
					</mat-form-field>
				</div>
				<div class="row take-full-width">
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
						<input
							matInput
							[disabled]="!device.id"
							[(ngModel)]="oneDayOrFlexCodeEdits.email"
							(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
							data-automation-id="email-input"
							[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
							class="email-input-field"
						/>
					</mat-form-field>
					<div class="margin-bottom-16" style="width: 100%">
						<app-contact-phone-type-form
							class="new-mobile-form-width"
							[isDisabled]="!device.id"
							[existingPhoneNumber]="mobilePhone"
							(userPhoneNumber)="updateUserPhone($event)"
							[optional]="true"
						>
						</app-contact-phone-type-form>
					</div>
				</div>
			</div>
		}
	</ng-template>

	<ng-template #deviceLocation>
		<div class="device-location-info">
			<div class="column body-text">
				<span class="color-type-tertiary" i18n="@@deviceGenerateOneDayCode-addresTitle">Address</span>
				@if (
					this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.address1 &&
					this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.locality &&
					this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.postalCode
				) {
					<p>
						{{
							this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.address1
						}},
						{{
							this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.locality
						}},
						{{
							this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
								?.postalCode
						}}
					</p>
				}
				@if (
					!this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.address1 ||
					!this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.locality ||
					!this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.postalCode
				) {
					<p>- - -</p>
				}
			</div>

			<div class="column body-text">
				<span class="color-type-tertiary" i18n="@@deviceGenerateOneDayCode-propertyNameTitle">Property Name</span>
				<p>
					{{ this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name ?? '- - -' }}
				</p>
			</div>

			<div class="column body-text">
				<span class="color-type-tertiary" i18n="@@deviceGenerateOneDayCode-deviceLocationTitle">Device Location</span>
				<p>{{ this.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name ?? '- - -' }}</p>
			</div>
		</div>
	</ng-template>

	<!-- Code generation tabs -->
	<ng-template #codeGenerateTabs>
		@if (
			!fromDeviceScreen &&
			hasValidDeviceSelected() &&
			!(
				this.fetchingDeviceControlSummaries ||
				(this.resultingDeviceAccess?.length ?? 0) === 0 ||
				this.resultingDeviceAccess
			)
		) {
			<mat-divider></mat-divider>
		}
		@if (!isPDQDevice && !isSentriVaultDeviceFlag) {
			<div class="bottom-spacing-32" id="code-tabs">
				<mat-tab-group
					#codeGenTabGroup
					id="code-gen-tab"
					class="remove-border-bottom"
					mat-stretch-tabs
					(selectedTabChange)="onTabChanged($event)"
					[(selectedIndex)]="codeGenTabIndex"
				>
					<div class="row">
						<mat-tab (click)="isOneDayCodeDisabled()" label="access-code">
							<ng-template mat-tab-label>
								@if (isHaspCodeGenForm) {
									<div class="icon-container column">
										<mat-icon svgIcon="sl-access-code-gen"></mat-icon>
										<p
											class="tab-icon-text tab-text"
											i18n="@@deviceGenerateOneDayCode-accessCodeTab"
											data-automation-id="deviceGenerateOneDayCode-accessCodeTab"
										>
											Access Code
										</p>
									</div>
								}
								@if (!isHaspCodeGenForm) {
									<div class="icon-container column">
										<mat-icon svgIcon="sl-access-code-gen-filled"></mat-icon>
										<p
											class="tab-icon-text-selected tab-text"
											i18n="@@deviceGenerateOneDayCode-accessCodeTab"
											data-automation-id="deviceGenerateOneDayCode-accessCodeTab"
										>
											Access Code
										</p>
									</div>
								}
							</ng-template>
						</mat-tab>
						<mat-tab (click)="isOneDayCodeDisabled()" label="hasp-code">
							<ng-template mat-tab-label>
								@if (!isHaspCodeGenForm) {
									<div class="icon-container column">
										<mat-icon svgIcon="sl-hasp-code-gen"></mat-icon>
										<p
											class="tab-icon-text tab-text"
											i18n="@@deviceGenerateOneDayCode-haspCodeTab"
											data-automation-id="deviceGenerateOneDayCode-haspCodeTab"
										>
											Hasp Code
										</p>
									</div>
								}
								@if (isHaspCodeGenForm) {
									<div class="icon-container column">
										<mat-icon svgIcon="sl-hasp-code-gen-filled"></mat-icon>
										<p
											class="tab-icon-text-selected tab-text"
											i18n="@@deviceGenerateOneDayCode-haspCodeTab"
											data-automation-id="deviceGenerateOneDayCode-haspCodeTab"
										>
											Hasp Code
										</p>
									</div>
								}
							</ng-template>
						</mat-tab>
					</div>
				</mat-tab-group>
			</div>
		}
		@if (isHaspCodeGenForm) {
			<!-- Reason for hasp code generation -->
			<div>
				<div class="sn-lookup-columns">
					<div class="display-flex">
						<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
							<div class="flex-row-space-between">
								<div
									id="hasp-code-generation-label"
									class="drawer-dialog-content-header large-title-formatting"
									i18n="@@deviceGenerateCodeDialog-codeGeneration"
									data-automation-id="deviceGenerateCodeDialog-codeGeneration"
								>
									Code Generation
								</div>
							</div>
							<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
								<mat-label
									class="mat-label-color"
									i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
									data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
									>Reason for Generation</mat-label
								>
								<textarea
									class="text-area-size"
									[required]="reasonRequireForGenerationReasonRequired"
									matInput
									[maxLength]="600"
									[disabled]="!device.id"
									cdkTextareaAutosize
									[cdkAutosizeMinRows]="1"
									[(ngModel)]="oneDayOrFlexCodeEdits.reason"
									(ngModelChange)="isOneDayCodeDisabled()"
									data-automation-id="generate-hasp-code-reason-textarea"
								>
								</textarea>
							</mat-form-field>
						</div>
						@if (fromDeviceScreen && device.deviceGeneration) {
							<div class="margin-left-32" style="line-height: 2.6em">
								@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
									<div>
										<img
											class="lb-img"
											src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
											alt="Gen 4 Lockbox"
											data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
										/>
									</div>
								}
								@if (!device.deviceGeneration.toLowerCase().includes('gen4')) {
									<div>
										<img
											class="lb-img"
											src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
											alt="Gen 3 Lockbox"
											data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
										/>
									</div>
								}
							</div>
						}
					</div>
				</div>
			</div>
			<mat-divider></mat-divider>
			<!-- New device location for hasp code generation -->
			<div>
				<div class="row row-between margin-bottom-8">
					<div class="property-text-container">
						<p i18n="@@deviceGenerateOneDayCode-removeFromPropertyPrompt">
							Will the device be removed from the property?
						</p>
					</div>
					<div>
						<mat-button-toggle-group
							class="remove-from-property-toggle"
							[value]="true"
							[hideSingleSelectionIndicator]="true"
						>
							<mat-button-toggle
								[value]="false"
								(change)="onRemoveToggle($event.value)"
								data-automation-id="remove-from-property-no-toggle"
								i18n="@@deviceGenerateOneDayCode-removePropertyNoToggle"
								>No
							</mat-button-toggle>
							<mat-button-toggle
								[value]="true"
								(change)="onRemoveToggle($event.value)"
								data-automation-id="remove-from-property-yes-toggle"
								i18n="@@deviceGenerateOneDayCode-removePropertyYesToggle"
								>Yes
							</mat-button-toggle>
						</mat-button-toggle-group>
					</div>
				</div>
				@if (!willRemoveFromProperty) {
					<div id="new-location-box" class="column display-flex">
						<div class="row">
							<div
								id="hasp-code-generation-label"
								class="drawer-dialog-content-header large-title-formatting"
								i18n="@@deviceGenerateCodeDialog-newLocationTitle"
							>
								New Device Location
							</div>
							<p class="spacing-left new-location-optional" i18n="@@deviceGenerateCodeDialog-newLocationOptionalCaps">
								(Optional)
							</p>
						</div>
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
							<textarea
								class="text-area-size"
								matInput
								[maxLength]="600"
								[disabled]="!device.id"
								cdkTextareaAutosize
								[cdkAutosizeMinRows]="1"
								[(ngModel)]="oneDayOrFlexCodeEdits.newLocation"
								(ngModelChange)="isOneDayCodeDisabled()"
								data-automation-id="generate-hasp-code-new-location-textarea"
								[placeholder]="newLocationPlaceholder"
							></textarea>
						</mat-form-field>
						<mat-divider></mat-divider>
					</div>
				}
			</div>
			<!-- Date valid for hasp code generation -->
			@if (device.id) {
				<div>
					<div class="flex-row-space-between">
						<div
							class="drawer-dialog-content-header large-title-formatting"
							i18n="@@deviceGenerateOneDayCode-dateValidTitle"
						>
							Date Valid
						</div>
						<span class="asterisk-text">*</span>
					</div>
					<div class="take-full-width spacing-column-16">
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
							<input
								required
								matInput
								[formControl]="dateTimeControl"
								[disabled]="!device.id"
								[min]="minStartDate"
								[max]="maxStartDate"
								[matDatepicker]="picker"
								[matDatepickerFilter]="myFilter"
								[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
								(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
								(ngModelChange)="transformValidDate($event)"
								data-automation-id="start-datepicker-input"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="picker"
								data-automation-id="start-datepicker-toggle"
							>
								<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
							</mat-datepicker-toggle>
							<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
						</mat-form-field>
						<div class="column"></div>
					</div>
				</div>
			}
			<mat-divider></mat-divider>
			<!-- Contact form for hasp code generation -->
			<div class="flex-row-space-between">
				<div
					class="drawer-dialog-content-header large-title-formatting"
					i18n="@@deviceGenerateOneDayCode-assignToTitle"
				>
					Assign To
				</div>
			</div>
			<div class="column">
				<div class="column take-full-width">
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
						<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName">First Name</mat-label>
						<input
							required
							matInput
							[disabled]="!device.id"
							[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
							(ngModelChange)="isOneDayCodeDisabled()"
							data-automation-id="first-name-input"
						/>
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
						<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName">Last Name</mat-label>
						<input
							required
							matInput
							[disabled]="!device.id"
							[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
							(ngModelChange)="isOneDayCodeDisabled()"
							data-automation-id="last-name-input"
						/>
					</mat-form-field>
				</div>
				<div class="row take-full-width">
					<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
						<input
							matInput
							[disabled]="!device.id"
							[(ngModel)]="oneDayOrFlexCodeEdits.email"
							(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
							data-automation-id="email-input"
							[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
							class="email-input-field"
						/>
					</mat-form-field>
					<div class="margin-bottom-16" style="width: 100%">
						<app-contact-phone-type-form
							class="new-mobile-form-width"
							[isDisabled]="!device.id"
							[existingPhoneNumber]="mobilePhone"
							(userPhoneNumber)="updateUserPhone($event)"
							[optional]="true"
						>
						</app-contact-phone-type-form>
					</div>
				</div>
			</div>
			@if (isWallMountDevice) {
				<div class="wall-mount-no-hasp-gen-message-container">
					<mat-icon svgIcon="sl-danger-triangle"></mat-icon>
					<span class="wall-mount-no-hasp-gen-message" i18n="@@deviceGenerateOneDayCode-wallMountNoHaspGen">
						Wall-mounted devices cannot generate hasp codes.
					</span>
				</div>
			}
		} @else {
			@if (!!device.id) {
				<div>
					<div class="sn-lookup-columns">
						<div class="display-flex">
							<div class="row-end display-flex sn-lookup-columns sn-lookup-columns column">
								<!-- Reason for code generation input field -->
								<div class="flex-row-space-between">
									<div
										id="access-code-generation-label"
										class="drawer-dialog-content-header large-title-formatting"
										i18n="@@deviceGenerateCodeDialog-codeGeneration"
									>
										Code Generation
									</div>
								</div>
								<mat-form-field subscriptSizing="dynamic" appearance="outline" class="code-gen-textarea-field">
									<mat-label
										class="mat-label-color"
										i18n="@@deviceGenerationCodeDialog-ReasonForGeneration"
										data-automation-id="deviceGenerateCodeDialog-reasonForGeneration-title"
										>Reason for Generation</mat-label
									>
									<textarea
										class="text-area-size"
										[required]="reasonRequireForGenerationReasonRequired"
										matInput
										[maxLength]="600"
										[disabled]="!device.id"
										cdkTextareaAutosize
										[cdkAutosizeMinRows]="1"
										[(ngModel)]="oneDayOrFlexCodeEdits.reason"
										(ngModelChange)="isOneDayCodeDisabled()"
										data-automation-id="generate-access-code-textarea"
									>
									</textarea>
								</mat-form-field>
							</div>
							<!-- Device generation icon visible if coming from device screen -->
							@if (fromDeviceScreen && device.deviceGeneration) {
								<div class="margin-left-32" style="line-height: 2.6em">
									@if (device.deviceGeneration.toLowerCase().includes('gen4') && !isSentriVaultDeviceFlag) {
										<div>
											<img
												class="lb-img"
												src="${environment.deployPath}/../assets/icons/gen-4-lockbox.png"
												alt="Gen 4 Lockbox"
												data-automation-id="deviceGenerateCodeDialog-gen4LockboxDeviceImage"
											/>
										</div>
									}
									@if (device.deviceGeneration.toLowerCase().includes('gen3')) {
										<div>
											<img
												class="lb-img"
												src="${environment.deployPath}/../assets/icons/gen-3-lockbox.png"
												alt="Gen 3 Lockbox"
												data-automation-id="deviceGenerateCodeDialog-gen3LockboxDeviceImage"
											/>
										</div>
									}
									@if (device.deviceGeneration.includes(PDQ_KMS_GENERATION_1)) {
										<div>
											<img
												class="lb-img kms-lockset-img"
												src="${environment.deployPath}/../assets/icons/senturian-1-kms.png"
												alt="Senturian Series Deadbolt"
												data-automation-id="deviceGenerateCodeDialog-santurianSeriesDeadboltDeviceImage"
											/>
										</div>
									}
									@if (device.deviceGeneration.includes(PDQ_SDS_GENERATION_1)) {
										<div>
											<img
												class="lb-img sds-lockset-img"
												src="${environment.deployPath}/../assets/icons/senturian-1-sds.png"
												alt="Senturian Series Cylindrical"
												data-automation-id="deviceGenerateCodeDialog-santurianSeriesCylindricalDeviceImage"
											/>
										</div>
									}
									<!-- Added for the Sentri-Vault image based on conditionally : -->
									@if (isSentriVaultDeviceFlag) {
										<div>
											<img
												class="lb-img sds-lockset-img"
												src="${environment.deployPath}/../assets/icons/sentrivault.png"
												alt="SentriVault"
												data-automation-id="deviceGenerateCodeDialog-sentrivaultDeviceImage"
											/>
										</div>
									}
								</div>
							}
						</div>
					</div>
				</div>
				<mat-divider></mat-divider>
				@if (device.deviceGeneration) {
					<div>
						@if (showStartAndEndDateTimeframe()) {
							<div>
								<div class="timeframe-header">
									<div class="timeframe-title-row">
										<div
											class="drawer-dialog-content-header large-title-formatting margin-bottom-8"
											i18n="@@deviceGenerateOneDayCode-durationTitle"
										>
											Duration
										</div>
										<div class="align-items-start display-flex align-content-end">
											<mat-checkbox
												class="align-items-start row-end display-flex non-overlapping-checkbox"
												[checked]="!oneDayOrFlexCodeEdits.locked"
												[disabled]="!device.id"
												(change)="oneDayOrFlexCodeEdits.locked = !oneDayOrFlexCodeEdits.locked"
												i18n="@@deviceGenerateOneDayCode-nonOverlappingCheckbox"
												data-automation-id="non-overlapping-checkbox"
												>Non-Overlapping</mat-checkbox
											>
											<mat-icon
												class="tooltip-icon mobile-tooltip-icon"
												svgIcon="sl-info-circle"
												[matTooltip]="nonOverlappingTooltip"
												matTooltipClass="mobile-tooltip"
												(click)="$event.stopPropagation()"
												(touchend)="$event.stopPropagation()"
												[attr.aria-label]="nonOverlappingTooltip"
												role="button"
												tabindex="0"
											>
											</mat-icon>
										</div>
									</div>
									<div class="content-sub-title" i18n="@@deviceGenerateOneDayCode-timezoneBasedOnLocation">
										Time zone based on device location
									</div>
								</div>
								<!-- Multi-day hour timeframe for non-hasp code generation -->
								<div class="date-time-container">
									<div class="column-double">
										<div class="flex-row-space-between">
											<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startDateTitle">
												Start Date
											</div>
											<span class="asterisk-text">*</span>
										</div>
										<mat-form-field subscriptSizing="dynamic" appearance="outline" class="placeholder-text-style">
											<input
												required
												matInput
												[formControl]="dateTimeControl"
												[disabled]="!device.id"
												[min]="minStartDate"
												[max]="maxStartDate"
												[matDatepicker]="startDatePicker"
												[matDatepickerFilter]="myFilter"
												[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
												(ngModel)="(this.oneDayOrFlexCodeEdits.startDate)"
												(ngModelChange)="transformStartDate($event)"
												data-automation-id="start-datepicker-input"
											/>
											<mat-datepicker-toggle
												matSuffix
												[for]="startDatePicker"
												data-automation-id="start-datepicker-toggle"
											>
												<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
											</mat-datepicker-toggle>
											<mat-datepicker #startDatePicker data-automation-id="start-datepicker"></mat-datepicker>
											@if (dateTimeControl.hasError('required')) {
												<mat-error
													i18n-placeholder="@@deviceGenerateCodeDialog-startDateError"
													data-automation-id="start-datepicker-error"
													>Make sure to select a valid Start Date</mat-error
												>
											}
										</mat-form-field>
									</div>
									<div class="column">
										<div class="flex-row-space-between">
											<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-startTimeTitle">
												Start Time
											</div>
											<span class="asterisk-text">*</span>
										</div>
										<app-military-time-picker
											class="select-border"
											[passedInTime]="this.oneDayOrFlexCodeEdits.startTime"
											[endTimeMustBeAfter]="startTimeMustBeAfter"
											[endTimeMustBeBefore]="startTimeMustBeBefore"
											(onTimeSelected)="onStartTimeSelected($event)"
											data-automation-id="start-date-military-time-picker"
										>
										</app-military-time-picker>
									</div>
								</div>
								<div class="date-time-container">
									<div class="column-double">
										<div class="flex-row-space-between">
											<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endDateTitle">End Date</div>
											<span class="asterisk-text">*</span>
										</div>
										<mat-form-field subscriptSizing="dynamic" appearance="outline">
											<input
												required
												matInput
												#endDateInput
												[formControl]="endDateTimeControl"
												[disabled]="!device.id"
												[min]="minEndDate"
												[max]="maxEndDate"
												[matDatepicker]="endDatePicker"
												[matDatepickerFilter]="myFilter"
												[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
												(ngModel)="(this.oneDayOrFlexCodeEdits.endDate)"
												(ngModelChange)="transformEndDate($event)"
												data-automation-id="end-datepicker-input"
											/>
											<mat-datepicker-toggle
												matSuffix
												class="date-picker-primary-blue"
												[for]="endDatePicker"
												data-automation-id="end-datepicker-toggle"
											>
												<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
											</mat-datepicker-toggle>
											<mat-datepicker #endDatePicker data-automation-id="end-datepicker"></mat-datepicker>
											@if (endDateTimeControl.hasError('required')) {
												<mat-error
													i18n-placeholder="@@deviceGenerateCodeDialog-endDateError"
													data-automation-id="end-datepicker-error"
													>Make sure to select a valid End Date</mat-error
												>
											}
										</mat-form-field>
									</div>
									<div class="column">
										<div class="flex-row-space-between">
											<div class="label-text-formatting" i18n="@@deviceGenerateOneDayCode-endTimeTitle">End Time</div>
											<span class="asterisk-text">*</span>
										</div>
										<app-military-time-picker
											class="select-border"
											[passedInTime]="this.oneDayOrFlexCodeEdits.endTime"
											[endTimeMustBeAfter]="endTimeMustBeAfter"
											[endTimeMustBeBefore]="endTimeMustBeBefore"
											(onTimeSelected)="onEndTimeSelected($event)"
											data-automation-id="end-date-military-time-picker"
										>
										</app-military-time-picker>
									</div>
								</div>
							</div>
						}
						<!-- Single day date valid for non-hasp code generation -->
						@if (!showStartAndEndDateTimeframe()) {
							<div>
								<div class="flex-row-space-between">
									<div
										class="drawer-dialog-content-header large-title-formatting"
										i18n="@@deviceGenerateOneDayCode-dateValidTitle"
									>
										Date Valid
									</div>
									<span class="asterisk-text">*</span>
								</div>
								<div class="take-full-width spacing-column-16">
									<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
										<input
											required
											matInput
											[formControl]="dateTimeControl"
											[disabled]="!device.id"
											[min]="minStartDate"
											[max]="maxStartDate"
											[matDatepicker]="picker"
											[matDatepickerFilter]="myFilter"
											[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
											(ngModel)="(this.oneDayOrFlexCodeEdits.utcValidDate)"
											(ngModelChange)="transformValidDate($event)"
											data-automation-id="start-datepicker-input"
										/>
										<mat-datepicker-toggle
											matSuffix
											class="date-picker-primary-blue"
											[for]="picker"
											data-automation-id="start-datepicker-toggle"
										>
											<mat-icon matDatepickerToggleIcon svgIcon="sl-nav-calendar"></mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
									</mat-form-field>
									<div class="column"></div>
								</div>
							</div>
						}
					</div>
				}
				<mat-divider></mat-divider>
				<!-- Contact form for non-hasp code generation -->
				<div class="flex-row-space-between">
					<div
						class="drawer-dialog-content-header large-title-formatting"
						i18n="@@deviceGenerateOneDayCode-assignToTitle"
					>
						Assign To
					</div>
				</div>
				<div class="column">
					<div class="column take-full-width">
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
							<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-firstName">First Name</mat-label>
							<input
								required
								matInput
								[disabled]="!device.id"
								[(ngModel)]="oneDayOrFlexCodeEdits.firstName"
								(ngModelChange)="isOneDayCodeDisabled()"
								data-automation-id="first-name-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
							<mat-label class="mat-label-color" i18n="@@deviceGenerateOneDayCode-lastName">Last Name</mat-label>
							<input
								required
								matInput
								[disabled]="!device.id"
								[(ngModel)]="oneDayOrFlexCodeEdits.lastName"
								(ngModelChange)="isOneDayCodeDisabled()"
								data-automation-id="last-name-input"
							/>
						</mat-form-field>
					</div>
					<div class="row take-full-width">
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="margin-bottom-16" style="width: 100%">
							<input
								matInput
								[disabled]="!device.id"
								[(ngModel)]="oneDayOrFlexCodeEdits.email"
								(ngModelChange)="isOneDayCodeDisabled(); updateEmailToggleCheckboxes()"
								data-automation-id="email-input"
								[placeholder]="emailPlaceholder + ' (' + optionalPlaceholder + ')'"
								class="email-input-field"
							/>
						</mat-form-field>
						<div class="margin-bottom-16" style="width: 100%">
							<app-contact-phone-type-form
								class="new-mobile-form-width"
								[isDisabled]="!device.id"
								[existingPhoneNumber]="mobilePhone"
								(userPhoneNumber)="updateUserPhone($event)"
								[optional]="true"
							>
							</app-contact-phone-type-form>
						</div>
					</div>
				</div>
			}
		}
	</ng-template>

	<!-- Buttons for closing, generating code, and returning to devices -->
	@if (canIssueFlexCodes) {
		@if (!codeSuccessfullyGenerated) {
			@if (hasValidDeviceSelected()) {
				<mat-dialog-actions>
					<div class="row row-end">
						<div class="bottom-border"></div>
						<button
							class="secondary-small-button"
							(click)="onCloseClicked()"
							i18n="@@deviceGenerateOneDayCode-cancel"
							data-automation-id="device-gen-code-cancel-button"
						>
							Cancel
						</button>
						<button
							class="primary-small-button primary-small-button-wider margin-right-32"
							[ngStyle]="{ opacity: disableCodeGenerateButton ? '.5' : '1' }"
							i18n="@@deviceGenerateOneDayCode-generateCode"
							[disabled]="disableCodeGenerateButton"
							appDebounceClick
							(debounceClick)="generateCodes()"
							data-automation-id="generate-code-button"
						>
							Generate Code
						</button>
					</div>
					<div class="actions-spacer"></div>
				</mat-dialog-actions>
			}
		}
		@if (codeSuccessfullyGenerated) {
			<mat-dialog-actions class="margin-bottom-0">
				<div class="row row-end">
					<div class="bottom-border"></div>
					@if (fromDeviceScreen) {
						<button
							class="primary-small-button primary-small-button-wider primary-button-return-to-devices margin-right-32"
							i18n="@@deviceGenerateOneDayCode-returnToDevicesButton"
							(click)="returnToDevicesClicked()"
							data-automation-id="return-to-devices-button"
						>
							View Code List
						</button>
					}
					@if (!fromDeviceScreen) {
						<button
							class="secondary-small-button margin-right-32"
							(click)="onCloseClicked()"
							i18n="@@deviceGenerateOneDayCode-close"
							data-automation-id="device-gen-code-footer-close-button"
						>
							Close
						</button>
					}
				</div>
				<div class="actions-spacer"></div>
			</mat-dialog-actions>
		}
	}
</div>

<!-- Wall mounted device warning message -->
